"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.handleDDLUpdate = exports.dispatchAndHistoryUpdate = exports.dispatchUpdateToSubscribers = exports.playbackDDLHistory = exports.actionCreators = exports.actionTypes = void 0;

var _dset = require("dset");

var _merge = require("dset/merge");

var _json = require("klona/json");

var _deepDiff = require("deep-diff");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var DDL_LOCATION = 'ddl';
var actionTypes = {
  DDL_UPDATE: 'DDL_UPDATE',
  ADD_SUBSCRIBER: 'ADD_SUBSCRIBER',
  REMOVE_SUBSCRIBER: 'REMOVE_SUBSCRIBER'
};
exports.actionTypes = actionTypes;
var actionCreators = {
  updateDDL: function updateDDL(_ref) {
    var name = _ref.name,
        value = _ref.value,
        enableDiff = _ref.enableDiff,
        flushWith = _ref.flushWith;
    return {
      type: actionTypes.DDL_UPDATE,
      name: name,
      value: value,
      enableDiff: enableDiff,
      flushWith: flushWith
    };
  },
  // eslint-disable-next-line max-len
  addSubscriber: function addSubscriber(_ref2) {
    var subscriber = _ref2.subscriber,
        handler = _ref2.handler;
    return {
      type: actionTypes.ADD_SUBSCRIBER,
      subscriber: subscriber,
      handler: handler
    };
  },
  removeSubscriber: function removeSubscriber(_ref3) {
    var subscriber = _ref3.subscriber;
    return {
      type: actionTypes.REMOVE_SUBSCRIBER,
      subscriber: subscriber
    };
  }
}; // playback all events in history for subscriber and add to subscribers list

exports.actionCreators = actionCreators;

var playbackDDLHistory = function playbackDDLHistory(history, handler) {
  history.forEach(function (change) {
    return handler(change);
  });
};

exports.playbackDDLHistory = playbackDDLHistory;

var addSubscriber = function addSubscriber(state, action) {
  try {
    if (state.history.length > 0) {
      playbackDDLHistory(_toConsumableArray(state.history), action.handler);
    } else {
      playbackDDLHistory([].concat(_toConsumableArray(state.history), [_objectSpread({}, state.ddl)]), action.handler);
    }
  } catch (error) {
    console.error("react-ddl: Subscriber failed during history playback and could not be added: ".concat(action.subscriber, ",  ").concat(error.message), error);
    return state;
  }

  (0, _merge.dset)(state, "subscribers.".concat(action.subscriber), action.handler);
  return state;
};

var dispatchUpdateToSubscribers = function dispatchUpdateToSubscribers(_ref4) {
  var _ref4$subscribers = _ref4.subscribers,
      subscribers = _ref4$subscribers === void 0 ? {} : _ref4$subscribers,
      ddl = _ref4.ddl;
  Object.entries(subscribers).forEach(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        name = _ref6[0],
        handler = _ref6[1];

    try {
      handler(ddl);
    } catch (error) {
      console.error("react-ddl:subscriber:".concat(name, " Failed to handle DDL update"), error);
    }
  });
};

exports.dispatchUpdateToSubscribers = dispatchUpdateToSubscribers;

var dispatchAndHistoryUpdate = function dispatchAndHistoryUpdate(newState, state) {
  dispatchUpdateToSubscribers(newState);

  if (state.historyLimit) {
    state.history.push((0, _json.klona)(newState.ddl));
  }

  if (state.history && state.historyLimit < state.history.length) {
    state.history.shift();
  }
};

exports.dispatchAndHistoryUpdate = dispatchAndHistoryUpdate;

var handleDDLUpdate = function handleDDLUpdate(state, action) {
  var updateLocation = "".concat(DDL_LOCATION, ".").concat(action.name);
  var prevDDL = (0, _json.klona)(state.ddl);

  if (action.name && !action.value) {
    // eslint-disable-next-line no-param-reassign
    delete state[DDL_LOCATION][action.name];
  }

  (0, _merge.dset)(state, updateLocation, action.value);
  var newState = state;
  var diffSet = {};
  /*
    The fourth argument expects an object with a push method.
    The push method is getting updates on what field has changed and we are creating a
    simple object to house the names of the fields that have changed.
    We use an object key to keep field names as there can be duplicates
    changes in the same field.
  */
  // eslint-disable-next-line no-unused-expressions

  prevDDL !== undefined ? (0, _deepDiff.diff)(prevDDL, newState.ddl, null, {
    push: function push(a) {
      diffSet[a.path[0]] = true;
    }
  }) : dispatchAndHistoryUpdate(newState, state);

  if (Object.keys(diffSet).length > 0) {
    if (action.enableDiff) {
      // Then, we take all the keys from the object and add it to the DDL.
      (0, _dset.dset)(newState, "".concat(DDL_LOCATION, ".diff"), Object.keys(diffSet));
    }

    dispatchAndHistoryUpdate(newState, state);
  }

  if (action.flushWith) {
    (0, _dset.dset)(newState, updateLocation, action.flushWith);
  }

  return newState;
};

exports.handleDDLUpdate = handleDDLUpdate;

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    subscribers: {}
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  try {
    switch (action.type) {
      // update ddl if valid and send update to all subscribers
      case actionTypes.DDL_UPDATE:
        {
          return typeof action.name === 'string' ? handleDDLUpdate(_objectSpread({}, state), action) : state;
        }
      // Add a new ddl subscriber: key and function

      case actionTypes.ADD_SUBSCRIBER:
        {
          return addSubscriber(_objectSpread({}, state), action);
        }
      // remove ddl subscriber from list

      case actionTypes.REMOVE_SUBSCRIBER:
        {
          var newState = _objectSpread({
            subscribers: {}
          }, state);

          delete newState.subscribers[action.subscriber];
          return newState;
        }

      default:
        return state;
    }
  } catch (error) {
    console.error("react-ddl:action:".concat(action.type, " Failed"), error);
    return state;
  }
};

var _default = reducer;
exports.default = _default;